import type { State } from './typings'
import type { SchedulingScreen } from '../../../typings'

export function selectActiveScreen(state: State) {
  return state.stack[state.stack.length - 1]
}

export function selectScreenMeta(state: State, screen: SchedulingScreen) {
  const active = selectActiveScreen(state) === screen
  const seen = state.stack.includes(screen)
  return {
    active,
    seen,
  }
}
